<template>
  <div>
	<div class="form-group">
		<div class="form-check form-check-inline">
		<input class="form-check-input" type="checkbox" id="inlineCheckbox1"  v-model="value" @change="changeValue" @keyup="changeValue">
		<label class="form-check-label" for="inlineCheckbox1">{{$t('ct-active')}} </label>
		</div>
	</div>

    <div class="form-group">
      <label>
        {{$t('ct-arrow-size')}}
        <input type="number" :min="min" :max="max" class="custom-input form-control input-border-number"
               v-model="valueSize"
               @change="changeValue" @keyup="changeValue">
      </label>
    </div>
    <div class="form-group">
      <label>
        {{$t('ct-arrow-color')}}
        <color-picker-component ref="colorPicker"></color-picker-component>
      </label>
    </div>
  </div>

</template>

<script>

	import ColorPickerComponent from "./Abstract/ColorPicker";

	export default {
		name: 'ArrowComponent',
		components: {ColorPickerComponent},
		data() {
			return {
				options: [
					'none',
					'dotted',
					'dashed',
					'solid',
					'double'
				],
				element: null,
				value: '',
				valueSize: '',
				valueColor: '',
				labelDesc: 'opa',
				callback: null,
				min: 0,
				max: 100,
			}
		},
		methods: {
			changeValue() {
				this.callback();
			},
			setValues(obj) {

				// console.log(obj);

				let vm = this;

				this.value = obj.defaultValue;
				this.valueSize = obj.defaultSize;
				this.valueColor = obj.defaultColor;

				this.element = obj.element;
				this.labelDesc = this.$t(`ct-${obj.labelDesc}`);
				this.callback = obj.callback;


				let newObj = Object.assign({}, obj);
				newObj.defaultValue = this.valueColor
				newObj.callback = (value) => {
					vm.valueColor = value;
					vm.changeValue()
				};
				this.$refs.colorPicker.setValues(newObj);
			}
		},
	}

</script>

<style scoped lang="scss">
  .form-group {
    overflow: hidden;
  }

  .place-border-resource {
    display: flex;
  }

  .input-border-number,
  .border-color {
    width: 70px !important;
    min-width: 70px;
  }
</style>





// WEBPACK FOOTER //
// src/components/editor/resources/Arrow.vue